import React from 'react';
import '../../styles/layout.css';

/**
 * GridCellElement - Individual cell in a grid container
 * Can span multiple rows/columns with configurable flexbox layout
 */
const GridCellElement = ({ element, children, isEditorMode }) => {
  const { props } = element;
  const {
    rowSpan = 1,
    columnSpan = 1,
    rowStart,
    columnStart,
    padding = 'medium',
    backgroundColor = 'transparent',
    // Flexbox layout controls
    flexDirection = 'column',
    justifyContent = 'flex-start',
    alignItems = 'stretch',
    gap = 'small'
  } = props || {};

  // Map gap values to CSS values
  const gapMap = {
    none: '0',
    small: '0.25rem',
    medium: '0.5rem',
    large: '1rem'
  };

  const cellStyle = {
    gridRow: rowStart ? `${rowStart} / span ${rowSpan}` : `span ${rowSpan}`,
    gridColumn: columnStart ? `${columnStart} / span ${columnSpan}` : `span ${columnSpan}`,
  };

  if (backgroundColor && backgroundColor !== 'transparent') {
    cellStyle.backgroundColor = backgroundColor;
  }

  // Apply flex layout to grid-cell-content
  const contentStyle = {
    flexDirection,
    justifyContent,
    alignItems,
    gap: gapMap[gap] || gapMap.medium
  };

  // Add span info for debugging in editor mode
  const spanInfo = isEditorMode && (rowSpan > 1 || columnSpan > 1) ?
    `${rowSpan}×${columnSpan}` : '';

  return (
    <div
      className={`grid-cell ${isEditorMode ? 'grid-cell-editor-mode' : ''}`}
      data-padding={padding}
      data-span-info={spanInfo}
      style={cellStyle}
    >
      <div className="grid-cell-content" style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

export default GridCellElement;
